import createIcon from '../../createIcon';

/**
 * @component @name PhoneBluetoothSpeaker
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNzEgMTAuNUwxNyA4LjIxVjEySDE3LjVMMjAuMzUgOS4xNUwxOC4yMSA3TDIwLjM2IDQuODVMMTcuNSAySDE3VjUuNzlMMTQuNzEgMy41TDE0IDQuMjFMMTYuNzkgN0wxNCA5Ljc5TDE0LjcxIDEwLjVaTTE4IDMuOTFMMTguOTQgNC44NUwxOCA1Ljc5VjMuOTFaTTE4IDguMjFMMTguOTQgOS4xNUwxOCAxMC4wOVY4LjIxWk0yMCAxNi41QzE4Ljc1IDE2LjUgMTcuNTUgMTYuMyAxNi40MyAxNS45M0MxNi4wOCAxNS44MiAxNS42OSAxNS45IDE1LjQxIDE2LjE3TDEzLjIxIDE4LjM3QzEwLjM4IDE2LjkzIDguMDYgMTQuNjIgNi42MiAxMS43OEw4LjgyIDkuNTdDOS4xIDkuMzEgOS4xOCA4LjkyIDkuMDcgOC41N0M4LjcgNy40NSA4LjUgNi4yNSA4LjUgNUM4LjUgNC40NSA4LjA1IDQgNy41IDRINEMzLjQ1IDQgMyA0LjQ1IDMgNUMzIDE0LjM5IDEwLjYxIDIyIDIwIDIyQzIwLjU1IDIyIDIxIDIxLjU1IDIxIDIxVjE3LjVDMjEgMTYuOTUgMjAuNTUgMTYuNSAyMCAxNi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhoneBluetoothSpeaker = createIcon('PhoneBluetoothSpeaker', [
  [
    'path',
    {
      d: 'M14.71 10.5L17 8.21V12H17.5L20.35 9.15L18.21 7L20.36 4.85L17.5 2H17V5.79L14.71 3.5L14 4.21L16.79 7L14 9.79L14.71 10.5ZM18 3.91L18.94 4.85L18 5.79V3.91ZM18 8.21L18.94 9.15L18 10.09V8.21ZM20 16.5C18.75 16.5 17.55 16.3 16.43 15.93C16.08 15.82 15.69 15.9 15.41 16.17L13.21 18.37C10.38 16.93 8.06 14.62 6.62 11.78L8.82 9.57C9.1 9.31 9.18 8.92 9.07 8.57C8.7 7.45 8.5 6.25 8.5 5C8.5 4.45 8.05 4 7.5 4H4C3.45 4 3 4.45 3 5C3 14.39 10.61 22 20 22C20.55 22 21 21.55 21 21V17.5C21 16.95 20.55 16.5 20 16.5Z',
      key: '1mwyp8',
    },
  ],
]);

export default PhoneBluetoothSpeaker;
